import React, { PureComponent } from 'react';

import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class PlayerReportStatistic extends PureComponent {
  static defaultProps = {
    value: '-'
  };

  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.string
  };

  render() {
    const { label, value } = this.props;

    return (
      <div className="player__report__statistic">
        <label className="label__description player__report__statistic__label">
          <I18n label={label} />
        </label>
        <span className="player__report__statistic__value">{value}</span>
      </div>
    );
  }
}
